import React from "react";

// Refined interlocked MM monogram - two elegant serif Ms sharing the central stem
// Inspired by classical luxury monograms (Didone/Bodoni style)
const MMLogo = ({ size = 56, className = "" }) => {
  const id = React.useId();

  return (
    <svg
      width={size * 1.35}
      height={size}
      viewBox="0 0 200 130"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Rose gold gradient - refined */}
        <linearGradient id={`g-${id}`} x1="0%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="#E9CFAA" />
          <stop offset="30%" stopColor="#BE9769" />
          <stop offset="55%" stopColor="#8B6238" />
          <stop offset="80%" stopColor="#AF8556" />
          <stop offset="100%" stopColor="#6E4F30" />
        </linearGradient>
        {/* Softer secondary gradient for back M */}
        <linearGradient id={`g2-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#EAD3B0" />
          <stop offset="50%" stopColor="#C8A277" />
          <stop offset="100%" stopColor="#9B7649" />
        </linearGradient>
        {/* Highlight strip */}
        <linearGradient id={`sh-${id}`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#F7E7CA" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#F7E7CA" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* ================ BACK M (right, softer gold) ================ */}
      <g fill={`url(#g2-${id})`} opacity="0.9">
        {/* Left stem (thin) */}
        <path d="M 82 22 L 88 22 L 88 108 L 82 108 Z" />
        {/* Left top hairline serif */}
        <path d="M 76 22 L 94 22 L 94 24 L 76 24 Z" />
        {/* Left bottom hairline serif */}
        <path d="M 74 108 L 96 108 L 96 110 L 74 110 Z" />
        {/* Right stem (thin) */}
        <path d="M 156 22 L 162 22 L 162 108 L 156 108 Z" />
        <path d="M 150 22 L 168 22 L 168 24 L 150 24 Z" />
        <path d="M 148 108 L 170 108 L 170 110 L 148 110 Z" />
        {/* Inner V - refined thin diagonals */}
        <path d="M 88 22 L 96 22 L 122 88 L 118 96 Z" />
        <path d="M 148 22 L 156 22 L 126 96 L 122 88 Z" />
      </g>

      {/* ================ FRONT M (left, rich gold, dominant) ================ */}
      <g fill={`url(#g-${id})`}>
        {/* Left stem */}
        <path d="M 22 22 L 32 22 L 32 108 L 22 108 Z" />
        {/* Left top serif with tapered ends */}
        <path d="M 12 22 L 42 22 L 42 25 L 34 25 L 34 28 L 20 28 L 20 25 L 12 25 Z" />
        {/* Left bottom serif */}
        <path d="M 10 108 L 10 105 L 20 105 L 20 100 L 34 100 L 34 105 L 44 105 L 44 108 Z" />
        {/* Right stem */}
        <path d="M 96 22 L 106 22 L 106 108 L 96 108 Z" />
        <path d="M 86 22 L 116 22 L 116 25 L 108 25 L 108 28 L 94 28 L 94 25 L 86 25 Z" />
        <path d="M 84 108 L 84 105 L 94 105 L 94 100 L 108 100 L 108 105 L 118 105 L 118 108 Z" />
        {/* Refined inner V with elegant taper */}
        <path d="M 32 22 L 44 22 L 68 92 L 60 100 Z" />
        <path d="M 86 22 L 96 22 L 68 100 L 60 92 Z" />
        {/* V tip dark accent */}
        <path d="M 60 96 L 68 96 L 64 108 Z" fill="#4A3320" opacity="0.5" />
      </g>

      {/* Vertical highlight strips on front M stems */}
      <rect x="23" y="25" width="2" height="78" fill={`url(#sh-${id})`} />
      <rect x="97" y="25" width="2" height="78" fill={`url(#sh-${id})`} />

      {/* Subtle vertical shine on back M */}
      <rect x="83" y="25" width="1.5" height="78" fill={`url(#sh-${id})`} opacity="0.6" />
      <rect x="157" y="25" width="1.5" height="78" fill={`url(#sh-${id})`} opacity="0.6" />
    </svg>
  );
};

export default MMLogo;
